import { Link, LinkProps } from '@mui/material';
import { Link as RRLink, LinkProps as RRLinkProps } from 'react-router-dom';

const RouterLink = ({ to, children, ...rest }: LinkProps & RRLinkProps) => (
  <Link component={RRLink} to={to} {...rest} underline="hover">
    {children}
  </Link>
);

export default RouterLink;
